// extracted by mini-css-extract-plugin
export default {"productDescription":"R--z","featuredDescription":"S--z","description":"T--z","more":"U--z","descriptionSku":"V--z"};